// Shared quick-add guard: decides whether a menu item can be one-tap added to
// the cart with empty modifiers, or must go through the item customization
// sheet because skipping it would drop a hard-required choice.

// Relative, not "@/", so React Native can bundle this file verbatim — Metro
// does not resolve the web tsconfig alias. Both targets are siblings in
// src/lib and are themselves import-free.
import { getTemplateForItem } from "./order-config";
import { getPizzaSizeOptionsFromPriceText } from "./menu-price-options";

export type CustomizableMenuItem = {
  _id: string;
  name: string;
  category: string;
  price: number;
  priceText?: string;
  restaurantId?: string;
  locationId?: string;
};

/**
 * True when adding `item` without choices would bypass a required selection.
 * Mirrors the item customization sheet's required-group validation:
 * - the resolved template demands a choice (temperature always; pizza when
 *   the price text encodes the two-size split). Resolution goes through
 *   getTemplateForItem so per-item overrides (e.g. Carne Asada keeping the
 *   temperature requirement after the category rescope) apply here exactly
 *   as they do in the sheet, or
 * - the item belongs to a required Convex modifier group
 *   (`idsWithRequiredModifiers` from menu.getMenuItemIdsWithRequiredModifiers).
 */
export function itemRequiresCustomization(
  item: CustomizableMenuItem,
  idsWithRequiredModifiers: Set<string>,
): boolean {
  if (idsWithRequiredModifiers.has(item._id)) return true;

  const template = getTemplateForItem(item);
  if (template === "temperature") return true;
  if (template === "pizza") {
    return (
      getPizzaSizeOptionsFromPriceText(item.priceText, item.price).length > 0
    );
  }

  return false;
}
